var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"HeaderRow"},[_vm._l((_vm.columns),function(column){return [(column.isActive)?_c('th',{key:column.text,class:column.class,domProps:{"innerHTML":_vm._s(column.text)}}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }